import { Component, OnInit, Input, Optional, Inject } from "@angular/core";
import { FromFieldControl } from "../form-field-control";
import { FormGroupDirective } from "@angular/forms";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";

@Component({
    selector: "tc-masked-form-field",
    templateUrl: "./masked-form-field.component.html",
    styleUrls: ["./masked-form-field.component.scss"],
    standalone: false
})
export class MaskedFormFieldComponent
	extends FromFieldControl
	implements OnInit {
	_autoCorrectedDatePipe: undefined;

	_placeholderDate = "01";
	_placeholderMonth = "01";
	_placeholderYear = "1900";

	@Input() maxLength = -1;
	@Input() minLength = -1;
	@Input() voidValidImage = false;
	@Input() noWrap = false;
	@Input() voidError = false;
	@Input() type = "text";

	_mask: any;

	@Input() set mask(val: (string | RegExp)[]) {
		if (val) {
			this._mask = {
				mask: val,
				guide: true,
				placeholderChar: "\u2000",
			};

			if (this._autoCorrectedDatePipe) {
				this._mask.pipe = this._autoCorrectedDatePipe;
			}
		}
	}

	@Input() set dateFormat(format: string) {
		if (format) {
			this._autoCorrectedDatePipe = createAutoCorrectedDatePipe(format);
			this.placeholder = format
				.replace("dd", this._placeholderDate)
				.replace("mm", this._placeholderMonth)
				.replace("yyyy", this._placeholderYear);

			if (this._mask) {
				this._mask.pipe = this._autoCorrectedDatePipe;
			}
		}
	}

	constructor(
		@Optional()
		@Inject(FormGroupDirective)
		__formGroupDirective: FormGroupDirective
	) {
		super(__formGroupDirective);
	}

	ngOnInit() {}

	getTheError(e): any {
		if (this.__control?.errors && !e) {
			return this.__control?.errors?.message;
		}
		return e;
	}

	get __hasError() {
		return (
			(this.__control.touched &&
				!this.valid &&
				this.__control.invalid &&
				!this.voidError) ||
			(this.__control.touched &&
				this.minLength > 0 &&
				this.invalidImage.length > 0 &&
				!this.voidError)
		);
	}

	get imageUrl() {
		return this.valid && this.validImage
			? this.voidValidImage
				? ""
				: this.validImage
			: this.invalidImage;
	}

	get showImage() {
		return (this.valid && this.validImage) || this.__hasError;
	}
}
